// extracted by mini-css-extract-plugin
export default {"addAddress":"AddAddress_addAddress__B6Si1","btns":"AddAddress_btns__XCGwB","blocked":"AddAddress_blocked__xDd-D"};